import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NotificationsComponent } from "../notifications/notifications/notifications.component";
import { FireBaseService } from "../../../../common/services/FireBase.service";
import { EvsUserService } from "../../../../common/services/EvsUser.service";
import { ModalModule } from 'ngx-bootstrap/modal';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule,ModalModule, TranslateModule.forChild()],
  declarations: [NotificationsComponent],
  providers: [FireBaseService, EvsUserService]
})
export class NotificationsModule {}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/notifications/notifications.module.ts